import React from "react"

const Header:React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-sky-500 to-indigo-500 h-11 flex justify-center items-center">
      <h2 className="text-white font-semibold text-center ">
      ++ AKTION FREIE VERSANKOSTEN ++
      </h2>
    </div>
  )
}

export default Header